export default {
  messages: {
    email: e => {
      return 'El campo ' + e + ' debe ser un correo electrónico válido.';
    },
    min_value: (e, n) => {
      return 'El campo ' + e + ' debe ser ' + n[0] + ' o superior.';
    },
  },
  attributes: {
    email: 'Correo electrónico',
  },
};
